import lf from 'lovefield'

export function const_options (schemaBuilder) {
  schemaBuilder.createTable('const_options')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('code', lf.Type.STRING)
      .addColumn('nom', lf.Type.STRING)
      .addColumn('const_famillesengins_id', lf.Type.INTEGER)
      .addPrimaryKey(['id'])
      // .addUnique('code', ['code'])
      // .addIndex('constFamillesengins_id', ['constFamillesengins_id']);
}


/*
CREATE TABLE IF NOT EXISTS `const-options` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `code` varchar(4) NOT NULL,
  `nom` varchar(20) NOT NULL,
  `const-famillesengins_id` int(11) NOT NULL,
  PRIMARY KEY (`id`),
  UNIQUE KEY `code` (`code`),
  KEY `const-famillesengins_id` (`const-famillesengins_id`)
) ENGINE=InnoDB  DEFAULT CHARSET=utf8 AUTO_INCREMENT=6 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constOptions.schema.js